module.exports = __webpack_public_path__ + "static/media/sombra-interna-debru-todo.55930b00.svg";